// @ts-strict-ignore
import {promisifyModal} from 'common/components/modal/utils';

import {SharingModalAttrs} from './modal/types';
// eslint-disable-next-line import/no-cycle -- sharing modal can sometimes render itself; usage is deferred so it's safe
import {SharingModalEl} from './modal';

export const sharingWidget = {
  promptSharing,
};

export function promptSharing(entity: Partial<SharingModalAttrs>, closeHandler = null) {
  return promisifyModal({
    panelElement: SharingModalEl,
    attrs: {
      ...entity,
    },
    closeEvents: [`submit`, `close`],
    closeHandler,
  });
}
